<template>
  <div class="wrap">
    <v-toolbar flat color="white">
      <v-toolbar-title>Список лендингов</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="isDeveloper"
            color="primary"
            dark
            class="mb-2"
            v-bind="attrs"
            v-on="on"
            >Создать</v-btn
          >
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Заголовок"
                    :error-messages="getErrors('name')"
                  ></v-text-field>
                </v-row>
                <v-row>
                  <v-textarea
                    name="input-7-1"
                    label="Описание"
                    rows="2"
                    v-model="editedItem.description"
                    :error-messages="getErrors('description')"
                  >
                  </v-textarea>
                </v-row>
                <v-row>
                  <v-text-field
                    v-model="editedItem.url"
                    label="Host"
                    :error-messages="getErrors('url')"
                  ></v-text-field>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Отмена</v-btn>
            <v-btn color="blue darken-1" text @click="save">Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <template v-if="items.length">
      <CardItem
        :items="items"
        :type="'landings'"
        :show-blocks-link="true"
        :hide-actions="!isDeveloper"
        @editItem="editItem"
        @deleteItem="deleteItem"
      />
      <template>
        <div class="text-center">
          <v-pagination
            v-if="pagesCount > 1"
            v-model="page"
            :length="pagesCount"
            @input="updatePagination"
          ></v-pagination>
        </div>
      </template>
    </template>
    <template v-else>
      <v-card-text>
        Список лендингов пуст
      </v-card-text>
    </template>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import CardItem from "@/components/CardItem";
import { GLOBAL } from "@/config/consts";
import errors from "@/mixins/errors";
import { mapGetters } from "vuex";

export default {
  components: { CardItem },
  data() {
    return {
      dialog: false,
      itemsPerPage: 20,
      count: 0,
      items: [],
      page: 1,
      editedIndex: -1,
      editedItem: {
        name: "",
        description: "",
        url: ""
      },
      defaultItem: {
        name: "",
        description: "",
        url: ""
      },
      multiLine: true,
      snackbar: false,
      errorText: "",
      global: GLOBAL,
      overlay: false
    };
  },
  mixins: [errors],
  computed: {
    ...mapGetters(["getErrorText", "isDeveloper"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Новый лендинг"
        : "Редактировать лендинг";
    },
    pagesCount() {
      return Math.ceil(this.count / this.itemsPerPage);
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      await this.getList(this.page);
    },
    async getList(page) {
      try {
        this.overlay = true;
        const { data } = await this.$axios.get(GLOBAL.apiUrl.landings, {
          params: {
            page: page,
            per_page: this.itemsPerPage
          }
        });
        this.items = data.list;
        this.count = data.count;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      if (confirm("Вы уверены, что хотите удалить этот элемент?")) {
        const index = this.items.indexOf(item);
        try {
          await this.$axios.delete(GLOBAL.apiUrl.landings + item.id);
          this.items.splice(index, 1);
        } catch ({ response }) {
          this.snackbar = true;
          this.errorText = this.getErrorText(response);
        }
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.clearErrors();
      });
    },
    async save() {
      const data = {
        name: this.editedItem.name,
        description: this.editedItem.description,
        url: this.editedItem.url
      };
      if (this.editedIndex > -1) {
        await this.saveCreated(data, this.items[this.editedIndex].id);
      } else {
        await this.saveNew(data);
      }
    },
    async saveCreated(saveData, id) {
      try {
        const { data } = await this.$axios.patch(
          GLOBAL.apiUrl.landings + id,
          saveData
        );
        Object.assign(this.items[this.editedIndex], data);
        this.close();
      } catch ({ response }) {
        this.setErrors(response.data);
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    },
    async saveNew(saveData) {
      try {
        const { data } = await this.$axios.post(
          GLOBAL.apiUrl.landings,
          saveData
        );
        this.items.unshift(data);
        this.close();
      } catch ({ response }) {
        this.setErrors(response.data);
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    },
    updatePagination(pagination) {
      this.getList(pagination);
    }
  }
};
</script>

<style>
.wrap {
  width: 100%;
}
.items-wrap .v-sheet.v-card {
  margin: 0 7px 25px !important;
  width: 374px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:first-child {
  max-width: 200px;
}
.buttons-wrap .v-btn:not(.v-btn--round).v-size--default {
  padding: 0;
  min-width: 46px;
}
.v-application--is-ltr .v-btn__content .v-icon--left {
  margin: 0 !important;
}
.items-wrap .v-card__actions {
  justify-content: space-between;
}
.items-wrap a {
  text-decoration: none;
}
</style>
